import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import propTypes from 'prop-types';
import useRequest from '../../../../Hooks/useRequest';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import { StyledButton } from '../../../../Components/Generics.styled';

const CreateACampaignContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const Title = styled.div`
    margin-top: 100px;
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
`;

const CampaignTypesContainer = styled.div`
    margin-top: 40px;
    height: 300px;
`;

const DropdownApplet = styled.div`
    margin-left: auto;
    margin-right: auto;
    height: 100px;
    text-align: center;

    .MuiSelect-outlined.MuiSelect-outlined {
        background-color: #fafbf7;
    }
`;

const StyledNavButtons = styled.div`
    display: flex;
    justify-content: space-evenly;
    /* width: 500px; */
    height: 70px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
`;

const NextBtn = styled(Button)`
    background: #2e69fe 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 40px;
    color: #fafbf7;

    &.MuiButton-contained.Mui-disabled {
        color: #fafbf7;
    }
    :disabled {
        background: #9b9b9d 0% 0% no-repeat padding-box !important;
    }
`;

const StyledSelect = styled(Select)`
    width: 100%;
    min-width: 300px;
    text-align: left;
`;

const CreateACampaign = (props) => {
    const {
        campaignData,
        setCampaignData,
        setPageIndex,
        setAdvertisers,
        advertisers,
        currentAdvertiser,
        setCurrentAdvertiser,
    } = props;
    const history = useHistory();
    const { data: campaignTypeData } = useRequest('/getAllCampaignTypes');

    useEffect(() => {
        setPageIndex(0);
        setCampaignData({
            stripePaymentId: campaignData.stripePaymentId,
            stripeCustomerId: campaignData.stripeCustomerId,
            advertiserName: campaignData.advertiserName,
            advertiserId: campaignData.advertiserId,
            agencyId: campaignData.agencyId,
            campaignTypeId: 0,
            campaignTypeCategoryId: 0,
            campaignTypeCategoryName: '',
            campaignTypeName: '',
            startDate: '',
            endDate: '',
            campaignName: '',
            headline: '',
            headline2: '',
            headline3: '',
            headline4: '',
            headline5: '',
            headline6: '',
            description: '',
            description2: '',
            description3: '',
            description4: '',
            brandName: '',
            offerDescription: '',
            productDescription: '',
            redemptionInstructions: '',
            websiteURL: '',
            budget: 0,
            googleCampaignKeywords: [],
            locations: [],
            file: {
                fileName: '',
                file: null,
            },
        });
    }, []);

    const handleNavNextButton = () => {
        history.push(`/portal/campaign/createACampaign/${campaignData?.campaignTypeId}`);

        const selectedCampaignType = campaignTypeData.find((item) => {
            if (item?.campaignTypeId === campaignData?.campaignTypeId) {
                return true;
            }
            return false;
        });

        setCampaignData({
            ...campaignData,
            campaignTypeName: selectedCampaignType?.campaignTypeName.toLowerCase(),
        });
    };

    const renderValue = () => {
        const selectedOptionData = campaignTypeData.find(
            (option) => option?.campaignTypeId === campaignData?.campaignTypeId
        );
        return selectedOptionData ? selectedOptionData.campaignTypeName : '';
    };

    return (
        <CreateACampaignContainer>
            <Title>Select Your Campaign Type</Title>

            <CampaignTypesContainer>
                <DropdownApplet>
                    <FormControl variant="outlined">
                        <InputLabel id="select-campaign-type-dropdown">
                            Select Campaign Type
                        </InputLabel>
                        <StyledSelect
                            labelId="select-campaign-type-dropdown"
                            id="select-campaing-type-dropdown-outlined"
                            renderValue={renderValue}
                            onChange={(e) =>
                                setCampaignData({
                                    ...campaignData,
                                    campaignTypeId: e.target.value,
                                })
                            }
                            label="Select Campaign Type"
                        >
                            {campaignTypeData?.map((item, idx) => {
                                return (
                                    <MenuItem key={idx} value={item?.campaignTypeId}>
                                        {item.campaignTypeName}
                                    </MenuItem>
                                );
                            })}
                        </StyledSelect>
                    </FormControl>
                </DropdownApplet>
                <StyledNavButtons>
                    <StyledButton
                        variant="contained"
                        color="primary"
                        onClick={() => handleNavNextButton()}
                        disabled={
                            campaignData?.campaignTypeId === '' ||
                            campaignData?.campaignTypeId === 0
                        }
                    >
                        Next
                    </StyledButton>
                </StyledNavButtons>
            </CampaignTypesContainer>
        </CreateACampaignContainer>
    );
};

CreateACampaign.propTypes = {
    campaignData: propTypes.shape({
        campaignTypeName: propTypes.string,
        campaignTypeId: propTypes.number,
        stripeCustomerId: propTypes.string,
        stripePaymentId: propTypes.string,
        advertiserId: propTypes.number,
        agencyId: propTypes.number,
        advertiserName: propTypes.string,
    }),
    setCampaignData: propTypes.func,
    advertisers: propTypes.shape({}),
    setAdvertisers: propTypes.func,
    currentAdvertiser: propTypes.shape({}),
    setCurrentAdvertiser: propTypes.func,
    setPageIndex: propTypes.func,
};

CreateACampaign.defaultProps = {
    campaignData: {},
    setCampaignData: () => {},
    advertisers: {},
    setAdvertisers: () => {},
    currentAdvertiser: {},
};
export default CreateACampaign;
